import { ArrowUpRight } from "lucide-react";

const zomatoUrl = "https://www.zomato.com/varanasi/hastag-multi-cuisine-restro-garden-pandeypur";

export default function OrderingStrip() {
  return (
    <section className="ordering-strip" aria-label="Online ordering" data-testid="online-ordering-strip">
      <div className="ordering-strip-inner">
        <div className="ordering-strip-copy">
          <span>Online ordering</span>
          <strong>A good evening, delivered.</strong>
        </div>
        <div className="ordering-strip-action">
          <span>Browse Hashtag on Zomato</span>
          <a href={zomatoUrl} target="_blank" rel="noreferrer" aria-label="Order Hashtag on Zomato" data-testid="online-ordering-zomato-link">
            Order online <ArrowUpRight aria-hidden="true" />
          </a>
        </div>
      </div>
    </section>
  );
}
